import Vue from "vue"
import Vuetify from "vuetify"
import "vuetify/dist/vuetify.min.css"
import "@mdi/font/css/materialdesignicons.css"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import i18n from "./i18n"

Vue.use(Vuetify)

const vuetify = new Vuetify({
  icons: { iconfont: "mdi" },
  theme: {
    themes: {
      light: {
        primary: "#2d6a4f",
        secondary: "#1a3a2a",
      },
    },
  },
})

Vue.config.productionTip = false

store.dispatch("auth/fetchMe").finally(() => {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount("#app")
})
